module.exports = global["SegmentIO"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/index.js-exposed
// module id = 71
// module chunks = 1